export type DeclarationAttestationFileName = 'Déclaration' | 'Attestation'

export const ALERTE_FILE_NAME = 'Alerte';

/**
 * Méthode qui génère le nom du fichier d'Attestation ou de Declaration
 */
export function generateDeclarationAttestationFileName(
  siren: string,
  raisonSociale: string,
  anneeCampagne: number,
  fileName: DeclarationAttestationFileName,
): string {
  const raison = raisonSociale.substring(0, 30);
  return `${siren}-${raison}-${anneeCampagne}-${fileName}`;
}